import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "flex justify-end q-gutter-md no-wrap" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!$props.advert.has_expired || $setup.mainStore.accountDetail?.is_premium)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!$props.advert.has_expired || $setup.mainStore.accountDetail?.is_premium)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  color: "grey-9",
                  "no-caps": "",
                  outline: "",
                  unelevated: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.setStatus(!$setup.active)))
                }, {
                  default: _withCtx(() => [
                    ($setup.active)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Inserat deaktiveren")
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_3, "Inserat aktivieren"))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!$props.advert.has_expired)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  color: "primary",
                  "no-caps": "",
                  outline: "",
                  unelevated: "",
                  to: {name: 'editAdvert', params: {uuid: $props.advert.uuid}}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "fas fa-pencil",
                      size: "xs"
                    }),
                    _cache[2] || (_cache[2] = _createTextVNode("  Inserat bearbeiten "))
                  ]),
                  _: 1,
                  __: [2]
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            color: "primary",
            "no-caps": "",
            outline: "",
            unelevated: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.extendAdvert($props.advert)))
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Inserat verlängern ")
            ])),
            _: 1,
            __: [3]
          }))
    ])
  ]))
}